import axios from "axios";
import API from "../api/axios.js";

export const getApplications = async () => {
    const response = await API.get("/dashboard");
    return response.data;
};

export const getAllApplications = async () => {
    const response = await API.get("/dashboard/applications");
    return response.data;
};

export const getAwardRanking = async () => {
    const response = await API.get("/application/ranking");
    return response.data;
};


export const getSuperAdminAwardRanking = async () => {
    const currentUserId = localStorage.getItem("userId");

    if (!currentUserId) {
        throw new Error("Logged-in user ID was not found.");
    }

    const response = await API.get(
        "/application/superadmin-ranking",
        {
            params: {
                currentUserId,
            },
        }
    );

    return response.data;
};
